import axiosConfig from "./axiosConfig";

interface HhDataDownloadResponse {
  url: string;
}

const postHhDataDownload = async (
  authToken: string,
  fileGuid: string
): Promise<HhDataDownloadResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/${fileGuid}/download`,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postHhDataDownload;
